import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminReports = lazy(() => import("@/pages/admin/AdminReports"));

export const Route = createFileRoute("/admin/reports")({
  component: AdminReports,
});
